export const PERSON_STATUS = {
  0: 'Invited',
  1: 'Pending',
  2: 'Submitted',
  3: 'Approved',
  4: 'Denied',
  Invited: 0,
  Pending: 1,
  Submitted: 2,
  Approved: 3,
  Denied: 4,
};

export const PERSON_VERIFICATION = {
  0: 'Ready',
  1: 'Processing',
  2: 'Completed',
  Ready: 0,
  Processing: 1,
  Completed: 2,
};

export const ADDRESS_PREFIX_PRIMARY = 'primary';
export const ADDRESS_PREFIX_MAILING = 'mailing';

export const COVERAGE_TYPE = [
  { label: 'Employee Only', value: 'Employee_Only' },
  { label: 'Employee + Spouse', value: 'Employee_Spouse' },
  { label: 'Employee + Child(ren)', value: 'Employee_Children' },
  { label: 'Employee + Family', value: 'Employee_Family' },
];

export const RELATIONSHIP_TYPE = [
  { label: 'Subscriber', value: 'Subscriber' },
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Child', value: 'Child' },
  { label: 'Legal Dependent', value: 'Legal_Dependent' },
];

export const GENDER_CHOICES = [
  { label: 'Male', value: 'M' },
  { label: 'Female', value: 'F' },
];
